import type { ScopeCatalog } from "./types.js";

const FALLBACK_CATALOG: ScopeCatalog = {
  products: [
    {
      routeValue: "se",
      canonical: "profit",
      label: "Profit",
      shortLabel: "SE",
      aliases: ["", "se", "profit"],
    },
    {
      routeValue: "sb",
      canonical: "sb",
      label: "SB",
      shortLabel: "SB",
      aliases: ["sb", "sbplus", "smallbusiness"],
    },
  ],
  defaultProductCanonical: "profit",
  cultures: [
    { culture: "nl", languageId: 1 },
    { culture: "en", languageId: 4 },
    { culture: "fr", languageId: 3 },
  ],
  defaultLanguageId: 1,
};

let activeCatalog: ScopeCatalog = FALLBACK_CATALOG;

export function applyScopeCatalog(
  catalog: ScopeCatalog | undefined | null,
): void {
  activeCatalog =
    catalog && catalog.products?.length ? catalog : FALLBACK_CATALOG;
}

export function getScopeCatalog(): ScopeCatalog {
  return activeCatalog;
}

function normalizeText(value: string | null | undefined): string {
  return (value ?? "").trim().toLowerCase();
}

export function isSbProduct(value: string | null | undefined): boolean {
  const sb = activeCatalog.products.find(
    (product) => product.canonical === "sb",
  );
  if (!sb) return false;
  const normalized = normalizeText(value);
  return (
    sb.routeValue === normalized ||
    sb.canonical === normalized ||
    sb.aliases.some((alias) => alias.toLowerCase() === normalized)
  );
}

// Canonical (search/AI) product form: "profit" | "sb".
export function normalizeProductScopeValue(
  value: string | null | undefined,
): string {
  return isSbProduct(value) ? "sb" : activeCatalog.defaultProductCanonical;
}

// Jonas language id: 1 | 3 | 4, falling back via culture then default.
export function normalizeLanguageId(
  value: number | string | null | undefined,
  culture?: string | null,
): number {
  const numeric =
    typeof value === "string" ? Number.parseInt(value, 10) : value;
  if (numeric === 1 || numeric === 3 || numeric === 4) return numeric;
  const byCulture = activeCatalog.cultures.find(
    (entry) => entry.culture === normalizeText(culture),
  );
  return byCulture?.languageId ?? activeCatalog.defaultLanguageId;
}
